module.exports = "https://www.niulinkcloud.cn/_next/static/media/pcBanner.3c92ad1db6038b2100ca3b920d629e37.png";